export default {
    apiServiceUrl: 'api'
}